export default __webpack_public_path__ + "static/media/calendar.69df6240.svg";